import { HttpClient } from '@opallabs/api'
import removePlacement from '../removePlacement'

const deletePlacement = ({ accountId, placementId }) =>
  HttpClient().delete(
    `/moments/accounts/${accountId}/placements/${placementId}`
  )

const destroyPlacement = (options) => (dispatch) =>
  deletePlacement(options)
    .then((response) => {
      if (response.status === 204) {
        dispatch(removePlacement(options.placementId))
      }

      return {}
    })
    .catch((err) => {
      console.log(err)
      throw err
    })

export default destroyPlacement
